import React, { useState } from "react";
import Select from "react-select";

const SelectDropDown = ({ options, setSelectedOptionCategory,styles ,selectedOptionCategory}) => {
  // console.log(options)
  const [selectedOption, setSelectedOption] = useState(selectedOptionCategory);
  selectedOption != null && setSelectedOptionCategory(selectedOption);
  return <Select styles={styles} placeholder="---Select---" isClearable  onChange={setSelectedOption} options={options} />;
};

export default SelectDropDown;


